import { Button, Input } from '@arco-design/web-react'
import { IconCopy } from '@arco-design/web-react/icon'
import { Message } from '@arco-design/web-react'

interface Props {
  label?: string
  value: string
}

/** 只读 URL / 文本行，带复制按钮 */
export default function CopyableLine({ label, value }: Props) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      Message.success('已复制')
    } catch {
      Message.error('复制失败')
    }
  }

  return (
    <div className="settings-copy-row">
      {label ? <div className="settings-copy-row__label">{label}</div> : null}
      <div className="settings-copy-row__body">
        <Input readOnly value={value} className="settings-copy-row__input" />
        <Button type="outline" size="small" icon={<IconCopy />} onClick={copy}>
          复制
        </Button>
      </div>
    </div>
  )
}
